import { decodeHTML } from 'entities'

/**
 * Matches an HTML start, end, or self-closing tag (`<tag ...>`, `</tag>`,
 * `<tag/>`). The char after `<` must be a letter so that prose comparisons like
 * "5 < 10" or "rated A < B" are preserved rather than swallowed as a tag.
 */
const HTML_TAG_REGEX = /<\/?[a-zA-Z][^>]*>/g

/**
 * Normalize an FAQ / rich-text display string that should be plain text or a
 * constrained inline-markdown subset — never HTML.
 *
 * FAQ answers and hub body copy are authored as plain prose (reports) or a tiny
 * inline-markdown grammar (hubs). Upstream sources — scraped pages, copied
 * report text, LLM output — occasionally leak HTML entities (`&amp;`, `&#39;`,
 * `&lt;`) or stray tags (`<strong>`, `<br>`). Every FAQ renderer interpolates
 * the string as React text (which auto-escapes) and none of them decode, so that
 * markup renders literally: users see `Tom &amp; Jerry` or a bare `<strong>`.
 * (FAQ escaping investigation, Jun 2026.)
 *
 * We decode entities first — so an entity-encoded tag like `&lt;strong&gt;`
 * becomes a real `<strong>` — then strip any HTML tags, leaving clean text that
 * React can safely re-escape for display. Decoding is idempotent for clean text,
 * and the guard skips strings with no `&` or `<` (the common case).
 */
export function decodeAndStripHtml(value: string): string {
  if (!value.includes('&') && !value.includes('<')) return value
  return decodeHTML(value).replace(HTML_TAG_REGEX, '')
}
